"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var HeartbeatIcon =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(HeartbeatIcon, _PureComponent);

  function HeartbeatIcon() {
    _classCallCheck(this, HeartbeatIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(HeartbeatIcon).apply(this, arguments));
  }

  _createClass(HeartbeatIcon, [{
    key: "render",
    value: function render() {
      var color = this.props.color;
      return _react2.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 40 35",
        style: {
          fill: color,
          enableBackground: 'new 0 0 63 63'
        }
      }, _react2.default.createElement("path", {
        className: "a",
        d: "M25,48.5l-3.883,7.765a1.249,1.249,0,0,1-2.258-.047l-4.445-9.867-2.344,5.6H4.72l14.257,14.57a1.392,1.392,0,0,0,2.008,0L35.25,51.953H26.727L25,48.5ZM36.992,35.227l-.187-.2a10.234,10.234,0,0,0-14.64,0l-2.18,2.234-2.18-2.226a10.22,10.22,0,0,0-14.64,0l-.187.187a10.726,10.726,0,0,0-.57,14.226h8l2.8-6.734a1.252,1.252,0,0,1,2.3-.031l4.547,10.1,3.828-7.648a1.248,1.248,0,0,1,2.234,0l2.156,4.312h9.289A10.726,10.726,0,0,0,36.992,35.227Z",
        transform: "translate(0.015 -31.95)"
      }));
    }
  }]);

  return HeartbeatIcon;
}(_react.PureComponent);

exports.default = HeartbeatIcon;